export default __webpack_public_path__ + "static/media/originic.bc02da1c.jpeg";